import * as React from 'react';
import { useField } from 'formik';
import Error from './Error';
import TooltipComponent from '../../TooltipComponent';

interface ITextareaProps {
  name: string;
  label: string;
  rows?: number;
  id: string;
  placeholder?: string;
  width?: string;
  className?: string;
  readonly?: boolean;
  required?: boolean;
  newStyle?: boolean;
  note?: string;
  tooltip?: string;
  warningMessage?: string;
  containerClass?: string;
  labelClass?: string;
  isChangeDetail?: string;
  disabled?: boolean;
}

const Textarea: React.FC<ITextareaProps> = (props) => {
  const [field, meta] = useField(props);
  let areaWidth = 'col-sm-9';

  if (props.width) {
    areaWidth = props.width;
  }

  let errBorder = '';
  if (meta.touched && meta.error) {
    errBorder = 'err-border';
  }

  const oldStyleContent: JSX.Element = (
    <div className="form-group" id={props.id}>
      <div className="text-left font-weight-bold col-sm-3 control-label">
        {props.required && <span className="text-danger text-danger required-field-info">* </span>}
        {props.label}
      </div>
      <div className={areaWidth}>
        <textarea
          {...field}
          // {...props}
          id={props.id}
          data-cy={`form-text-area-${props.name}`}
          className={`${props.className} form-control form-control-textarea ${errBorder}`}
          name={props.name}
          rows={props.rows}
          placeholder={props.placeholder || ''}
          readOnly={props.readonly}
          style={{ resize: 'none' }}
          title={props.tooltip || ''}
        />
        {meta.touched && meta.error && <Error message={meta.error} />}
      </div>
    </div>
  );

  const newStyleContent: JSX.Element = (
    <div
      className={`${props.containerClass || 'form-group'} ${
        meta.touched && meta.error && 'form-group-error'
      }`}
    >
      <div>
        <label className={props.labelClass || 'd-block form-label'}>
          {props.required && <span className="text-danger required-field-info">*</span>}
          {props.label}
          {props.note && (
            <>
              <br />
              <small>{props.note}</small>
            </>
          )}
        </label>
        <div className="d-block">
          {props.isChangeDetail !== undefined ? (
            <div
              style={{
                background: 'rgb(242, 242, 242)',
                border: '1px solid rgb(221, 221, 221)',
                minHeight: '84px',
                color: '#B3B3B3',
                borderRadius: '4px',
                padding: '7px',
              }}
            >
              <TooltipComponent
                id={props.id}
                firstItems={true}
                width="180px"
                positionRight={true}
                overlay={<div style={{ color: '#fff' }}>{props.isChangeDetail || '-'}</div>}
              >
                <span
                  style={{
                    background: 'rgb(61, 114, 200)',
                    padding: '2px 10px 3px 10px',
                    borderRadius: '11px',
                    opacity: 0.3,
                    color: 'rgb(0, 0, 0)',
                  }}
                >
                  {field.value}
                </span>
              </TooltipComponent>
            </div>
          ) : (
            <textarea
              {...field}
              id={props.id}
              data-cy={`form-text-area-${props.name}`}
              name={props.name}
              rows={props.rows}
              placeholder={props.placeholder || ''}
              readOnly={props.readonly}
              className={`${props.className || 'form-control'}`}
              title={props.tooltip || ''}
              disabled={props.disabled}
              style={props.disabled ? { cursor: 'not-allowed', color: '#999' } : {}}
            />
          )}
          {meta.touched && meta.error && <Error message={meta.error} newStyle={true} />}
          {props.warningMessage && <Error message={props.warningMessage} newStyle={true} />}
        </div>
      </div>
    </div>
  );

  return props.newStyle ? newStyleContent : oldStyleContent;
};

export default Textarea;
